import { Panel } from '@sorrem-client/ui/components';
import type { CraftingWorkbenchState } from '@sorrem-client/ui/features/CharacterHome/hooks';
import { CraftingItemStrip } from './components/CraftingItemStrip';
import { CraftingWorkbench } from './components/CraftingWorkbench';
import styles from './CraftingMainPanel.module.scss';

interface CraftingMainPanelProps {
    readonly workbench: CraftingWorkbenchState;
}

/**
 * Crafting's center panel (#287): the item strip to pick from, then the
 * workbench showing what crafting would make of the pick. Picking only
 * selects; items are moved in the Inventory tab.
 */
export function CraftingMainPanel({ workbench }: CraftingMainPanelProps): JSX.Element {
    return (
        <Panel className={styles.craftingMainPanel}>
            <CraftingItemStrip />
            <CraftingWorkbench workbench={workbench} />
        </Panel>
    );
}
